import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { useLocation, useNavigate } from "react-router-dom";
import * as ScrollArea from "@radix-ui/react-scroll-area";
import { useAuth } from "../../Contexts/AuthContext";
import { notifIcons } from "../../utilities/values";
import parse from 'html-react-parser';
import { useEffect } from "react";
import dayjs from "dayjs";
import { ScrollBar } from "../../Components/ScrollBar";

function Details() {

  const { state } = useLocation();
  const { user } = useAuth();

  const navigate = useNavigate();

  useEffect(() => {
    if (!state) {
      navigate("/notification");
    }
  }, [state]);

  const handleBack = () => {
    navigate(-1);
  };

  const renderNotifIcon = () => {
    let icon = null;
    if (notifIcons[state?.type]) {
      icon = <img alt="notif" src={notifIcons[state?.type]} width="100%" />;
    }
    return icon;
  };

  const renderDate=()=>{
    let date = null;
    if(state.dateTime){
      let current = dayjs().startOf('day');
      let notifDate = dayjs(state.dateTime).startOf('day');
      if(notifDate.isSame(current)){
        date = dayjs(state.dateTime).format("h:mm A");
      }else{
        date = dayjs(state.dateTime).format("MMMM DD, YYYY h:mm A");
      }
    }

    return date;
  }

  return (
    <div className="flex flex-col min-h-screen max-w-screen sm:bg-[#E7EEFA] items-start sm:items-center cursor-default">
      <div className="flex flex-col w-full sm:w-148 sm:bg-white min-h-screen sm:min-h-0 items-start sm:items-center rounded-xl sm:mt-24 ">
        <div className="w-full grid grid-cols-1 divide-y">
          <div className="flex flex-row p-3">
            <KeyboardArrowLeftIcon
              className="cursor-pointer"
              onClick={handleBack}
            />
            <div className="text-md font-bold flex-grow text-center">
              Notification
            </div>
          </div>
          <ScrollArea.Root className="w-full overflow-hidden">
            <ScrollArea.Viewport className="w-full h-[calc(100vh-48px)] sm:h-full rounded">
              <div className="p-4">
                <div className="flex items-center mb-4">
                  <div className="w-10 mr-3">{renderNotifIcon()}</div>
                  <div className="flex-1">
                    <p>{state?.subject || ""}</p>
                    <p className="text-[#60656d] text-[12px]">
                      {renderDate()}
                    </p>
                  </div>
                </div>
                <p className="text-[#383f49] text-[14px] my-1 mb-4">
                  Dear {user?.first_name + " " + user?.last_name},
                </p>
                <p className="text-[#383f49] text-[14px] my-1 mb-4">
                  {parse(state?.message || "")}
                </p>
                <p className="text-[#383f49] text-[14px] my-1">
                  Member Gateway
                </p>
              </div>
            </ScrollArea.Viewport>
            <ScrollBar />
          </ScrollArea.Root>
        </div>
        <div className="bg-white flex-grow" />
      </div>
    </div>
  );
}

export default Details;
